import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 bg-surface" data-id="element-11">
      <div className="max-w-7xl mx-auto px-6" data-id="element-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-13">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} data-id="element-14">
            <h2 className="text-3xl md:text-4xl font-semibold mb-6" data-id="element-15">
              Про агенцію
            </h2>
            <p className="text-lg text-secondary leading-relaxed mb-6" data-id="element-16">
              Ми — команда перфекціоністів. Наша філософія будується на
              створенні подій, які перевершують очікування.
            </p>
            <p className="text-lg text-secondary leading-relaxed" data-id="element-17">
              Від концепції до реалізації, ми дбаємо про кожну деталь, щоб ви
              могли насолоджуватися моментом.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="grid grid-cols-2 gap-4" data-id="element-18">
            <div className="bg-background p-8 rounded-3xl border border-border" data-id="element-19">
              <div className="text-3xl font-semibold text-primary mb-2" data-id="element-20">
                100%
              </div>
              <div className="text-sm text-secondary" data-id="element-21">Гарантія результату</div>
            </div>
            <div className="bg-background p-8 rounded-3xl border border-border" data-id="element-22">
              <div className="text-3xl font-semibold text-primary mb-2" data-id="element-23">
                10+
              </div>
              <div className="text-sm text-secondary" data-id="element-24">Років досвіду</div>
            </div>
            <div className="bg-background p-8 rounded-3xl border border-border col-span-2" data-id="element-25">
              <div className="text-3xl font-semibold text-primary mb-2" data-id="element-26">
                500+
              </div>
              <div className="text-sm text-secondary" data-id="element-27">
                Успішних подій по всьому світу
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}